import React from 'react'
import WidgetSelector from './WidgetSelector'

export default function WidgetWarehouseSelector({
  value,
  displayValue,
  warehouses,
  onChange,
  viewOnly,
  reloadDropdownData,
  disabled = false,
  size,
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        disabled={disabled}
        selectedValue={value}
        displayValue={displayValue}
        options={warehouses}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => {
          if (typeof reloadDropdownData === 'function') {
            reloadDropdownData()
          }
        }}
        placeHolder="Select Warehouses"
        showCloudIcon={true}
        size={size}
      />
    </React.Fragment>
  )
}
